import { render, staticRenderFns } from "./UserDetailDialog.vue?vue&type=template&id=dea1ce84&scoped=true"
import script from "./UserDetailDialog.vue?vue&type=script&lang=js"
export * from "./UserDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./UserDetailDialog.vue?vue&type=style&index=0&id=dea1ce84&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea1ce84",
  null
  
)

export default component.exports